import { Exception } from './exception';

export class UnhandledSwitchCaseException extends Exception {}
